import React from 'react';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

import { Article } from '../../../interfaces/homepage';
import ProArticles from './ProArticles';
import ProCTA from './ProCTA';
import ProHero from './ProHero';
import ProQuote from './ProQuote';
import ProSubscription from './ProSubscription';
import ProTeams from './ProTeams';

interface ProProps {
  defaultProOfferCode: string;
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
  proArticles: Article[];
}

const Pro = ({
  defaultProOfferCode,
  env,
  initialCurrentUser,
  isWebview,
  proArticles,
}: ProProps) => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <div className="px-16 sm:px-28">
        <div className="m-auto max-w-[1040px] overflow-hidden" id="pro-landing-page">
          <ProHero defaultProOfferCode={defaultProOfferCode} />
          <ProQuote />
          <ProSubscription />
          <ProCTA defaultProOfferCode={defaultProOfferCode} />
          <ProArticles proArticles={proArticles} />
        </div>
      </div>
      <ProTeams defaultProOfferCode={defaultProOfferCode} />
    </AppContextProvider>
  );
};

export default Pro;
